import type { ReactNode } from 'react';

interface InfoRowProps {
  label: string;
  value: ReactNode;
  mono?: boolean;
}

export function InfoRow({ label, value, mono = false }: InfoRowProps) {
  return (
    <div className="flex items-start gap-2 overflow-hidden">
      <span className="text-xs text-neutral-400 min-w-24 shrink-0">
        {label}:
      </span>
      <span
        className={`text-xs text-neutral-200 wrap-break-word ${mono ? 'font-mono break-all' : ''}`}
      >
        {value}
      </span>
    </div>
  );
}
